import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6e438961"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_43 = { class: "font-red" }


import { defineComponent, onMounted } from 'vue'
import { getI18n } from '../utils'
const __default__ = defineComponent({
  name: 'SupportDeviceView'
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

// setp 内必须由内容，否则被编译没了 getI18n 函数找不到
onMounted(async () => {
  console.log('enter')
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("strong", null, _toDisplayString(_unref(getI18n)('适用机型', 'Compatible Devices')), 1),
    _createElementVNode("p", null, [
      _createTextVNode("● " + _toDisplayString(_unref(getI18n)('海外版iPhone', 'iPhones purchased from countries outside China')), 1),
      _hoisted_2,
      _createTextVNode("     ■ iPhone XR, iPhone XS, iPhone XS Max, iPhone 11, iPhone Pro, iPhone 11 Pro Max, iPhone SE2020, iPhone 12, iPhone 12 Pro, iPhone 12 Pro Max, iPhone 12 Mini, iPhone 13, iPhone 13 Pro, iPhone 13 Pro Max, iPhone 13 Mini, iPhone 14, iPhone 14 Pro, iPhone 14 Pro Max, iPhone 14 Plus, iPhone 15, iPhone 15 Pro, iPhone 15 Pro Max, iPhone 15 Plus"),
      _hoisted_3,
      _createTextVNode(" ● " + _toDisplayString(_unref(getI18n)('港澳版iPhone', 'iPhones purchased in Hong Kong/Macao SAR')), 1),
      _hoisted_4,
      _createTextVNode("     ■ iPhone SE2020, iPhone XS, iPhone 12 mini, iPhone 13 mini, iPhone SE (2nd generation or after)"),
      _hoisted_5,
      _createTextVNode(" ● Samsung Galaxy S23"),
      _hoisted_6,
      _createTextVNode(" ● Samsung Galaxy S23+"),
      _hoisted_7,
      _createTextVNode(" ● Samsung Galaxy S23 Ultra"),
      _hoisted_8,
      _createTextVNode(" ● Samsung Galaxy S22"),
      _hoisted_9,
      _createTextVNode(" ● Samsung Galaxy S22+"),
      _hoisted_10,
      _createTextVNode(" ● Samsung Galaxy S22 Ultra"),
      _hoisted_11,
      _createTextVNode(" ● Samsung Galaxy S21+ 5G"),
      _hoisted_12,
      _createTextVNode(" ● Samsung Galaxy S21 Ultra 5G"),
      _hoisted_13,
      _createTextVNode(" ● Samsung Galaxy Note 20 FE 5G"),
      _hoisted_14,
      _createTextVNode(" ● Samsung Galaxy Note 20 FE"),
      _hoisted_15,
      _createTextVNode(" ● Samsung Galaxy Note 20 Ultra, Ultra 5G"),
      _hoisted_16,
      _createTextVNode(" ● Samsung Note 20+"),
      _hoisted_17,
      _createTextVNode(" ● Samsung Fold LTE model"),
      _hoisted_18,
      _createTextVNode(" ● Samsung Galaxy Z Flip"),
      _hoisted_19,
      _createTextVNode(" ● Samsung Galaxy S20, s20+ and S20 Ultra (Single SIM Nano-SIM and/or eSIM models)"),
      _hoisted_20,
      _createTextVNode(" ● Samsung Galaxy Z Fold2 5G"),
      _hoisted_21,
      _createTextVNode(" ● Samsung Galaxy Fold"),
      _hoisted_22,
      _createTextVNode(" ● Samsung Galaxy Z Flip3 5G"),
      _hoisted_23,
      _createTextVNode(" ● Samsung Galaxy Z Flip4"),
      _hoisted_24,
      _createTextVNode(" ● Samsung Galaxy Z Flip5 5G"),
      _hoisted_25,
      _createTextVNode(" ● Google Pixel Fold"),
      _hoisted_26,
      _createTextVNode(" ● Google Pixel 8 Pro"),
      _hoisted_27,
      _createTextVNode(" ● Google Pixel 8"),
      _hoisted_28,
      _createTextVNode(" ● Google Pixel 7 Pro"),
      _hoisted_29,
      _createTextVNode(" ● Google Pixel 7"),
      _hoisted_30,
      _createTextVNode(" ● Google Pixel 6 Pro"),
      _hoisted_31,
      _createTextVNode(" ● Google Pixel 6a"),
      _hoisted_32,
      _createTextVNode(" ● Google Pixel 6"),
      _hoisted_33,
      _createTextVNode(" ● Google Pixel 5a"),
      _hoisted_34,
      _createTextVNode(" ● Google Pixel 5"),
      _hoisted_35,
      _createTextVNode(" ● Google Pixel 4a"),
      _hoisted_36,
      _createTextVNode(" ● Google Pixel 4"),
      _hoisted_37,
      _createTextVNode(" ● Google Pixel 3 & 3XL ( Limited support )"),
      _hoisted_38,
      _createTextVNode(" ● Huawei P40 and P40 Pro (purchased outside mainland China)"),
      _hoisted_39,
      _createTextVNode(" ● Oppo Find X3 Pro (purchased outside mainland China)"),
      _hoisted_40,
      _createTextVNode(" ● Motorola Razr (2nd Gen)"),
      _hoisted_41,
      _createTextVNode(" ● Motorola Razr (1st Gen)"),
      _hoisted_42
    ]),
    _createElementVNode("p", _hoisted_43, _toDisplayString(_unref(getI18n)('内地版iPhone不支持 eSIM。', 'iPhones purchased from mainland China do not support eSIM.')), 1)
  ]))
}
}

})